import type { Task, TaskListItem } from "@myapp/contract";

type TaskLike = Pick<Task | TaskListItem, "status" | "schedule">;

/**
 * `schedule` is null exactly when the task is unscheduled — that absence *is* the state, there is
 * no separate flag (see the contract's note on `TaskListItemSchema`).
 */
export const isTaskScheduled = (task: TaskLike): boolean => task.schedule != null;

/** Nothing is reserved yet, so the board would be giving it its first Termin. */
export const canPlanTask = (task: TaskLike): boolean => !isTaskScheduled(task);

/**
 * Moving an existing Termin to another slot.
 *
 * A finished task is not moved from the list. The board is deliberately more permissive — an
 * elevated role may still drag a completed block there (`dragPolicy`) — but a list row is a
 * one-click shortcut, and offering it for work that is already done invites the misclick.
 */
export const canReplanTask = (task: TaskLike): boolean =>
  isTaskScheduled(task) && task.status !== "COMPLETED";
